import React from "react";
import { Timer } from "lucide-react";

const fmtMin = (m) => (m == null ? "—" : m < 60 ? `${Math.round(m)} min` : `${Math.floor(m / 60)}h ${Math.round(m % 60)}m`);

const Stat = ({ label, value, sub, tone = "text-zinc-100", testid }) => (
  <div className="rounded-lg bg-zinc-950 border border-zinc-800 p-3" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-widest text-zinc-500">{label}</div>
    <div className={`font-heading text-2xl font-bold mt-1 ${tone}`}>{value}</div>
    {sub && <div className="text-[11px] text-zinc-500">{sub}</div>}
  </div>
);

// Tempo medio reale "In preparazione → Pronto" per sede (ordini con timestamp nel periodo selezionato)
export default function PrepTimesCard({ data }) {
  if (!data) return null;
  const t = data.total || {};
  const lateTone = t.late_pct == null ? "text-zinc-100" : t.late_pct > 30 ? "text-red-300" : t.late_pct > 10 ? "text-amber-300" : "text-emerald-300";
  return (
    <div className="card-elev p-4 space-y-3" data-testid="prep-times-card">
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="flex items-center gap-2 font-heading font-semibold"><Timer className="h-4 w-4 text-sky-300" /> Tempi di preparazione</div>
          <div className="text-xs text-zinc-500">Tempo medio reale tra "In preparazione" e "Pronto" · ordini dal {data.from} al {data.to}</div>
        </div>
      </div>
      {t.orders === 0 ? (
        <div className="text-xs text-zinc-500 py-3" data-testid="prep-times-empty">Nessun ordine con tempi registrati nel periodo: i tempi vengono tracciati da quando lo staff segna "In preparazione" e poi "Pronto".</div>
      ) : (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            <Stat label="Ordini misurati" value={t.orders} testid="prep-total-orders" />
            <Stat label="Tempo medio reale" value={fmtMin(t.avg_actual_min)} tone="text-sky-300" testid="prep-total-actual" />
            <Stat label="Stima media dichiarata" value={fmtMin(t.avg_eta_min)} sub={t.avg_eta_min != null && t.avg_actual_min != null ? `${t.avg_actual_min > t.avg_eta_min ? "+" : ""}${Math.round(t.avg_actual_min - t.avg_eta_min)} min vs stima` : undefined} testid="prep-total-eta" />
            <Stat label="Ordini in ritardo" value={t.late_pct == null ? "—" : `${t.late_pct}%`} tone={lateTone} sub="oltre l'orario stimato" testid="prep-total-late" />
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="prep-times-table">
              <thead>
                <tr className="text-[10px] uppercase tracking-widest text-zinc-500 border-b border-zinc-800">
                  <th className="text-left py-2 pr-2">Sede</th>
                  <th className="py-2 text-right">Ordini</th>
                  <th className="py-2 text-right">Medio reale</th>
                  <th className="py-2 text-right">Stima media</th>
                  <th className="py-2 text-right">In ritardo</th>
                </tr>
              </thead>
              <tbody>
                {data.branches.map((b) => (
                  <tr key={b.branch_id || "none"} className="border-b border-zinc-800/60" data-testid={`prep-row-${b.branch_id || "none"}`}>
                    <td className="py-2 pr-2 text-zinc-200">{b.branch_name}</td>
                    <td className="py-2 text-right text-zinc-300">{b.orders}</td>
                    <td className="py-2 text-right text-sky-300 font-semibold">{fmtMin(b.avg_actual_min)}</td>
                    <td className="py-2 text-right text-zinc-400">{fmtMin(b.avg_eta_min)}{b.with_eta && b.with_eta < b.orders ? <span className="text-[10px] text-zinc-600"> ({b.with_eta}/{b.orders})</span> : null}</td>
                    <td className={`py-2 text-right ${b.late_pct == null ? "text-zinc-500" : b.late_pct > 30 ? "text-red-300" : b.late_pct > 10 ? "text-amber-300" : "text-emerald-300"}`}>{b.late_pct == null ? "—" : `${b.late_pct}%`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
